import React, { useContext, useState } from 'react';
import {
  BeneficiaryContainer,
  BeneficiaryWrapper,
  BeneficiaryContent,
  BeneficiaryLineFormItem,
  BeneficiaryLineFormLabel,
  BeneficiaryAddLine,
  BeneficiaryLineFormHeaderItem,
  BeneficiaryLineFormDeleteItem
} from './styles';
import Alert from '../../../components/Alert';
import InputDefault from '../../../components/InputDefault';
import InputDefaultMask from '../../../components/InputDefaultMask';
import ModalAction from '../../../components/ModalAction';
import Loader from '../../../components/Loader';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import { Form, FormRow, FormFooter } from '../../../components/FormTemplate/styles';
import { useForm, Controller } from 'react-hook-form';
import { ApSecureContext } from '../../../store';
  import { default as ApSecureTypes } from "../../../store/ApSecure/types";
import { apSecureChoseOptions } from '../../../helpers/enum';
import { useHistory, useLocation } from 'react-router-dom';
import colors from '../../../assets/styles/colors';
import { BsCheck, BsExclamation } from 'react-icons/bs';
import { postApSecure } from '../../../services/apSecure';

const BeneficiaryPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { apSecure, setApSecure } = useContext(ApSecureContext);
  const { handleSubmit, control, register, setValue, watch, errors } = useForm({ defaultValues: apSecure.beneficiaries });
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const fields = watch();

  async function initializeStateComponent() {
    setValue('nombre', apSecure.beneficiariesUserInfo.nombre);
    onSubmit();
    setIsLoading(false);
  }

  async function onSubmit(data) {
    try {
      setIsLoading(true);
      let beneficiaries = apSecure.beneficiaries;
      beneficiaries = [{id:0,nombres_apellidos:" ",porcentaje_asignado:" ",posicionHogar:" "}]
      /*const countPercentage = beneficiaries.map((item, key) => {
        return parseFloat(fields[`tasa${key}`].replace('% ', ''));
      }).reduce(function (total, value) {
        return total + value;
      }, 0);*/
      

      /*if(countPercentage !== 100) {
        setShowWarningModal(true)
        setIsLoading(false);
        return;
      }*/

      
      /*beneficiaries = beneficiaries.map(item => {
        return {
          nombres_apellidos: data[`nombres_apellidos${item.id}`],
          parentesco: data[`posicionHogar${item.id}`],
          porcentaje_asignado: parseFloat(data[`tasa${item.id}`].replaceAll('% ', ''))
        }
      })*/
      
      const req = {
        idCredito: location.idCredit,
        id_cliente: apSecure.credit.idCliente,
        id_paquete_seguro: apSecure.plan.id,
        id_usuario_crea: apSecure.credit.idAsesorPrincipal,      
        cliente_es_tomador: apSecure.option.id === apSecureChoseOptions[0].id ? true : false,
        beneficiariosSeguro: beneficiaries
      }

      /*if(apSecure.option.id === apSecureChoseOptions[1].id) {
        req.tomadorSeguroExterno = {
          documento: apSecure.taker.documento.replaceAll('.', ''),
          tipo_documento: apSecure.taker.tipo_documento.toUpperCase(),
          nombres_apellidos: apSecure.taker.nombres_apellidos,
          celular: apSecure.taker.celular.replaceAll(' ', ''),
          telefonoResidencia: apSecure.taker.telefonoResidencia.replaceAll(' ', ''),
          id_departamento: apSecure.taker.state.id,
          id_ciudad: apSecure.taker.city.id,
          direccionResidencia: apSecure.taker.direccionResidencia,
          email: apSecure.taker.email,
          estadoCivil: apSecure.taker.estadoCivil,
          fechaNacimiento: apSecure.taker.fechaNacimiento,
          genero: apSecure.taker.genero
        }

      }*/

      await postApSecure(req);
      history.push({
        pathname: '/admin/references',
        idCredit: location.idCredit
      })
      setIsLoading(false);
      //setShowSuccessModal(true);
    } catch (error) {
      console.log(error)
      console.log(error.response)
      setIsLoading(false);
    }
  }

  function addBeneficiary() {
    if(apSecure.beneficiaries.length < 3) {
      setApSecure({
        type: ApSecureTypes.SET_BENEFICIARIES,
        beneficiaries: [...apSecure.beneficiaries, { id: apSecure.beneficiaries.length, nombres_apellidos: '', porcentaje_asignado: '', posicionHogar: '' }]
      })
    }
  }

  function deleteFieldFromStore(field) {
    let beneficiaries = apSecure.beneficiaries;
    beneficiaries = beneficiaries.filter((item) => item.id !== field.id);

    setApSecure({
      type: ApSecureTypes.SET_BENEFICIARIES,
      beneficiaries,
    });
  }

  useState(() => {
    initializeStateComponent();
  }, [])

  return (
    <BeneficiaryContainer id="beneficiaries-page">
      <BeneficiaryWrapper>
        <BeneficiaryContent>
          <Form onSubmit={handleSubmit(onSubmit)} style={{marginTop: 20}}>
            {apSecure.option.id === apSecureChoseOptions[0].id && false && (
              <>
                <BeneficiaryLineFormLabel>
                  Datos del tomador - Vinculado (tomador del crédito)
                </BeneficiaryLineFormLabel>
                <FormRow col="1">
                  <Controller
                    as={InputDefault}
                    control={control}
                    label="Nombres y Apellido"
                    name="nombre"
                    id="nombre"
                    error={errors.nombre}
                    defaultValue={apSecure.beneficiariesUserInfo.nombre}
                    readOnly />
                </FormRow>
              </>
            )}
             {false && <Alert 
              default
              description="Agrega un máximo de 3 beneficiarios y distribuyendo entre ellos porcentajes hasta completar un 100%."
              style={{marginTop: 20}}
            />}
            {false && <div>
              {apSecure.beneficiaries.map(((item, key) => (
              <BeneficiaryLineFormItem key={item.id}>
                <BeneficiaryLineFormHeaderItem>
                  <BeneficiaryLineFormLabel>Beneficiario {item.id + 1} (Opcional)</BeneficiaryLineFormLabel>
                  {key > 0 && (
                    <BeneficiaryLineFormDeleteItem onClick={() => deleteFieldFromStore(item)}>Eliminar Valor</BeneficiaryLineFormDeleteItem>
                  )}
                </BeneficiaryLineFormHeaderItem>
                <FormRow col="1">
                  <Controller
                    as={InputDefault}
                    control={control}
                    error={errors[`nombres_apellidos${item.id}`]}
                    label="Nombre y Apellido"
                    name={`nombres_apellidos${item.id}`}
                    id={`nombres_apellidos${item.id}`}
                    value={item.nombre}
                    register={register({ required: "Este dato es obligatorio" })} />
                </FormRow>
                <FormRow col="2">
                  <Controller
                    as={InputDefault}
                    control={control}
                    error={errors[`posicionHogar${item.id}`]}
                    label="Parentesco"
                    name={`posicionHogar${item.id}`}
                    id={`posicionHogar${item.id}`}
                    value={item.posicionHogar}
                    register={register({ required: "Este dato es obligatorio" })} />
                  <Controller
                    as={InputDefaultMask}
                    control={control}
                    label="Porcentaje Asignado"
                    name={`tasa${item.id}`}
                    register={register({
                      required: "Este dato es obligatorio",
                    })}
                    id={`tasa${item.id}`}
                    error={errors[`tasa${item.id}`]}
                    mask="% 999"
                    value={item.tasa} />
                </FormRow>
              </BeneficiaryLineFormItem>
            )))}
            <BeneficiaryAddLine type="button" onClick={() => addBeneficiary()}>+ Agregar otro beneficiario</BeneficiaryAddLine>
              </div>}
            

            <FormFooter justify="flex-end">
              <SecondaryLargeButton type="submit">Siguiente</SecondaryLargeButton>
            </FormFooter>
          </Form>
        </BeneficiaryContent>
        {isLoading && <Loader />}
      </BeneficiaryWrapper>
      <ModalAction
        open={showWarningModal}
        setShowModal={setShowWarningModal}
        actionFunctionDownButton={() => setShowWarningModal(false)}
        title="Revisa la suma de los porcentajes asignados, la cual debe sumar un 100%"
        actionLabelFunctionDownButton="Seleccionar"
        backgroundIcon={colors.bgTertiary}
        bodyIcon={<BsExclamation size={32} color={colors.textPrimary} />} />
      <ModalAction
        open={showSuccessModal}
        setShowModal={setShowSuccessModal}
        actionFunctionDownButton={() => history.push({
          pathname: '/admin/references',
          idCredit: location.idCredit
        })}
        title="¡Muy bien!"
        description="Continúa con el proceso de Seguro de vida."
        actionLabelFunctionDownButton="Continuar"
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />
    </BeneficiaryContainer>
  )
}

export default BeneficiaryPage;
